import { compose, both, either, includes, prop } from 'ramda';
import { dotPathEq, dotPathSatisfies } from 'ramda-extension';

import { getEnvironment } from '../utils';

const { SUPPORT_EMAIL } = getEnvironment();
export const DEFAULT_MESSAGE = `We could not log you in. Either try again or contact ${SUPPORT_EMAIL} for help.`;

// For prospect (pre-register) requests where the user is already registered,
// the auth service is changing the HTTP 400 from the user service to a 403,
// and not preserving the code, so this will have to do for now.
export const isRegisteredUserError = compose(
  both(
    dotPathEq('status', 403),
    dotPathSatisfies(
      either(
        includes('is already a registered user'),
        includes(
          'Registered users are not allowed to register as a prospect user'
        )
      ),
      'message'
    )
  ),
  prop('error')
);

export const isEmailSubmissionError = (errorResponse) =>
  errorResponse?.error?.name === 'SubmissionError' &&
  errorResponse?.error?.errors?.email;

const isUnauthorizedError = (errorResponse) =>
  errorResponse?.name == 'UnauthorizedError';

export const selectReportableError = (errorResponse) => {
  if (
    isEmailSubmissionError(errorResponse) ||
    isUnauthorizedError(errorResponse)
  )
    return;
  return errorResponse.error?.message || errorResponse.message;
};

export const selectDisplayError = (errorResponse) => {
  if (isUnauthorizedError(errorResponse)) return errorResponse?.message;
  if (isEmailSubmissionError(errorResponse))
    return errorResponse.error.errors.email;
  return DEFAULT_MESSAGE;
};
